import type { SingleRecordResponse } from '@stakeholderlabs/types'
import { useApiGet } from '~/composables/api/useBaseFetch'
import type { Domain } from '~/types'

export const useVerifyTenantDomain = () => {
  const verify = () => {
    return useApiGet<SingleRecordResponse<Domain.Model>>(`/verify-tenant-domain/`)
  }

  return { verify }
}
